//@flow
import React from 'react';
import css from './idd-auth.css';
// import {
//   Actions
// } from './auth-actions';

type State = {
  username: string,
  password: string,
  rememberme: boolean
}
class LoginPanel extends React.Component < * , State > {

  state = {
    username: "",
    password: "",
    rememberme: true
  }

  handleSubmit() {
    console.log('submit')
    // Actions.tryLogin(this.state.username, this.state.password, this.state.rememberme)
  }

  setUsername(e: SyntheticInputEvent < * > ) {
    this.setState({
      username: e.target.value,
    })
  }
  setPassword(e: SyntheticInputEvent < * > ) {
    this.setState({
      password: e.target.value,
    })
  }
  setRememberMe(e: SyntheticInputEvent < * > ) {
    this.setState({
      rememberme: e.target.checked,
    })
  }

  render() {
    return <div className={css.formSigninWrapper}>
      <form className={css.formSignin}>
      <h2 className={css.formSigninHeading}>Please login</h2>
      <input type = "text"
    className={css.formControl}
    name="username"
    placeholder="Email Address"
    required autoFocus
    onChange={
      this.setUsername.bind(this)
    }
    />

    <input type="password"
    className={css.formControl}
    name = "password"
    placeholder = "Password"
    required
    onChange = {
      this.setPassword.bind(this)
    }
    />

    <label className="checkbox" >
      <input type="checkbox" checked={this.state.rememberme} value="remember-me" id="rememberMe" name="rememberMe" onChange={this.setRememberMe.bind(this)} />
    Remember me
      </label>
      <button className="btn btn-lg btn-primary btn-block" onClick={this.handleSubmit.bind(this)} type='button'>Login</button>
  </form>
  </div>
  }
}

export default LoginPanel;